function TrustBar() {
  const firms = [
    "Studio Lotus",
    "HOK India",
    "Morphogenesis",
    "Sanjay Puri Architects",
    "Design Consortium",
    "Serie Architects",
  ];

  return (
    <section className="trustbar">
      <div className="trustbar-hdr">
        <div className="eyebrow rv">
          <div className="eyebrow-dash"></div>
          <span className="eyebrow-text">Trusted By</span>
        </div>
        <h2 className="sec-title rv d1">
          <span style={{ color: "#fff" }}>India's Leading Design Firms</span>
          <br />
          <em>Partner With Us.</em>
        </h2>
      </div>

      <style>{`
        .marquee-outer {
          overflow: hidden;
          margin-top: 2.5rem;
          // border-top: 1px solid rgba(255, 251, 240, 0.5);
          // border-bottom: 1px solid rgba(255, 251, 240, 0.5);
          position: relative;
          width: 100%;
        }

        .marquee-track {
          display: flex;
          width: max-content;
          animation: trustScroll 18s linear infinite;
        }

        .marquee-track:hover {
          animation-play-state: paused;
        }

        .marquee-item {
          padding: 2.3rem 3.5rem;
          border-right: 1px solid rgba(255, 251, 240, 0.5);
          font-family: "Playfair Display", Georgia, serif;
          font-size: 16px;
          font-style: italic;
          font-weight: 500;
          color: #a6a39b;
          white-space: nowrap;
          transition: color 0.25s;
          cursor: default;
          flex-shrink: 0;
        }

        .marquee-item:hover {
          color: #c84b20;
        }

        @keyframes trustScroll {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
      `}</style>

      <div className="marquee-outer">
        {/* <div className="marquee-track">
         
          {firms.map((name) => (
            <div key={`a-${name}`} className="marquee-item">
              {name}
            </div>
          ))}
        
          {firms.map((name) => (
            <div key={`b-${name}`} className="marquee-item">
              {name}
            </div>
          ))}
        </div> */}
      </div>
    </section>
  );
}

export default TrustBar;